export default __webpack_public_path__ + "assets/images/others/e89f45e24b74471451e162bfa4be7d35.png";